module.exports = __webpack_public_path__ + "img/icon15.219433be.png";